// extracted by mini-css-extract-plugin
export var backdropBlur = "_76-0";
export var body = "_76-5";
export var bodyScroll = "_76-6";
export var columnFooter = "_76-7";
export var columnFooterFlush = "_76-8";
export var contentColumn = "_76-4";
export var frame = "_76-3";
export var heroContent = "_76-c";
export var heroOverlay = "_76-b";
export var image = "_76-a";
export var imageWrapper = "_76-9";
export var modal = "_76-1";
export var modalMain = "_76-2";
export var productHeader = "_76-d";
export var productHeaderIcon = "_76-e";
export var productHeaderName = "_76-f";
export var progressIndicator = "_76-g";